var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectItem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#03142a;}.cls-3{fill:#fff;}.cls-4{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.67,
    y: 8.67,
    width: 14.67,
    height: 14.67,
    rx: 4.17
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(-2.36 29.23) rotate(-80.78)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M17.46,16.52H16.25l.64,1.6a.23.23,0,0,1-.11.28l-.56.25a.2.2,0,0,1-.27-.11L15.34,17l-1,1.05a.2.2,0,0,1-.35-.15v-5a.21.21,0,0,1,.35-.15l3.26,3.43A.21.21,0,0,1,17.46,16.52Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.83,7.1A5.74,5.74,0,0,0,7.1,12.83h3.13a2.6,2.6,0,0,1,2.6-2.6Zm6.34,3.13a2.6,2.6,0,0,1,2.6,2.6H24.9A5.74,5.74,0,0,0,19.17,7.1Zm2.6,8.94a2.61,2.61,0,0,1-2.6,2.6V24.9a5.74,5.74,0,0,0,5.73-5.73Zm-8.94,2.6a2.61,2.61,0,0,1-2.6-2.6H7.1a5.74,5.74,0,0,0,5.73,5.73Zm-2.6-2.6V12.83H7.1v6.34Zm8.94,2.6H12.83V24.9h6.34Zm2.6-8.94v6.34H24.9V12.83Zm-8.94-2.6h6.34V7.1H12.83Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectItem);
export default __webpack_public_path__ + "static/media/select-item.38b52aca0f9589fa09fb9b3b1cce0768.svg";
export { ForwardRef as ReactComponent };